import React, { useEffect, useRef, useState } from "react";
import { Flex } from "antd";
import { clrs } from "../../constants/colors";
import MyText from "../../components/UI/Text/MyText";

const InfoItem = ({ number, textUp, textCenter, textBottom }) => {
  const [height, setHeight] = useState(0);

  const ref = useRef();

  useEffect(() => {
    if (ref.current) {
      setHeight(ref.current.clientHeight);
    }
  }, [ref]);

  return (
    <Flex
      ref={ref}
      style={{ width: "100%", maxWidth: 1440, position: "relative" }}
      gap={20}
      align={"center"}
      justify={"center"}
    >
      <Flex
        vertical
        gap={15}
        align={"center"}
        justify={"space-between"}
        style={{ height: height, position: "relative" }}
      >
        <div
          style={{
            backgroundColor: clrs.blackerBlue,
            width: 1,
            height: "100%",
          }}
        ></div>
        <Flex
          style={{
            width: 75,
            height: 75,
            padding: 20,
            backgroundColor: "#e8e8e8",
          }}
          align={"center"}
          justify={"center"}
        >
          <MyText strong style={{ fontSize: "1.2rem" }}>
            {number}
          </MyText>
        </Flex>
        <div
          style={{
            backgroundColor: clrs.blackerBlue,
            width: 1,
            height: "100%",
          }}
        ></div>
      </Flex>
      <Flex
        vertical
        gap={15}
        align={"flex-start"}
        justify={"space-between"}
        style={{
          height: "100%",
          width: "100%",
          padding: 20,
          backgroundColor: "#e8e8e8",
        }}
      >
        <MyText>{textUp}</MyText>
        <MyText strong style={{ color: clrs.blackerBlue, fontSize: "1.2rem" }}>
          {textCenter}
        </MyText>
        <MyText>{textBottom}</MyText>
      </Flex>
    </Flex>
  );
};

export default InfoItem;
